import { render, staticRenderFns } from "./EditAvatar.vue?vue&type=template&id=d01efc8c"
import script from "./EditAvatar.vue?vue&type=script&lang=js"
export * from "./EditAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports